module.exports = __webpack_public_path__ + "img/dep_stationeryandprint.359304f5.png";